import { useState } from "react"
import { format } from "date-fns"
import IcDoc2U from "@/assets/images/icons/ic-doc2u.png"
import { Button } from "@/components/ui/button"
import { Doc2UAttachments } from "@/modules/patients/detail/progress-note/doc2u/doc2u-attachments"
import { Doc2UDialog } from "@/modules/patients/detail/progress-note/doc2u/doc2u-dialog"
import { useUploadDoc2UReportMutation } from "@/modules/patients/detail/progress-note/doc2u/services/useUploadDoc2UReportMutation"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { useContextAppointment } from "@/modules/patients/hooks/useContextAppointment"
import { AppointmentAttachmentFragment$key } from "@/modules/waiting-room/services/__generated__/AppointmentAttachmentFragment.graphql"

interface Doc2UProps {
  appointmentAttachments: AppointmentAttachmentFragment$key
}

const Doc2U = ({ appointmentAttachments }: Doc2UProps) => {
  const appointmentId = useAppointmentParam()
  const [isDoc2UDialogVisible, setIsDoc2UDialogVisible] = useState(false)
  const [uploadDoc2UReport] = useUploadDoc2UReportMutation()
  const contextAppointment = useContextAppointment()
  const isDisabled = contextAppointment?.status && ["CLOSED", "CANCELLED"].includes(contextAppointment.status)

  const handleUpload = (dataURL: string) => {
    if (appointmentId) {
      const [, base64EncodedData] = dataURL.split(",")
      const byteCharacters = atob(base64EncodedData)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const fileName = `Consultation_Report_${format(new Date(), "yyyyMMdd_HHmm")}.pdf`
      const file = new File([byteArray], fileName)

      uploadDoc2UReport({
        appointmentId,
        file,
      })
    }
  }

  return (
    <div className="mx-4 mb-4 flex items-center gap-2">
      <Button
        data-testid="doc2u-button"
        variant="tertiary"
        className="size-10 p-2"
        disabled={isDisabled}
        onClick={() => setIsDoc2UDialogVisible(true)}>
        <img src={IcDoc2U} alt="" />
      </Button>
      <Doc2UAttachments appointmentAttachments={appointmentAttachments} />
      {isDoc2UDialogVisible && <Doc2UDialog onOpenChange={setIsDoc2UDialogVisible} onUpload={handleUpload} />}
    </div>
  )
}

export { Doc2U }
